import { render, staticRenderFns } from "./InfomationListPage.vue?vue&type=template&id=5118d609&"
import script from "./InfomationListPage.vue?vue&type=script&lang=js&"
export * from "./InfomationListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports